<!-- 用户信息展示 是否登录 未登录显示登录按钮 已登录显示用户名 -->
<template>
  <div class="user-info">
    <div class="user" v-if="user.userId">
      <img class="avatar" :src="user.avatar | avatar" alt="">
      <ul-dropdown>
        <div class="ul-dropdown__trigger">
          <span>{{user.name}}</span>
          <i class="iconfont icon-xialacaozuo"></i>
        </div>
        <ul-dropdown-menu slot="dropdown">
          <ul-dropdown-item @click.native="toMyHomePage">我的首页</ul-dropdown-item>
          <ul-dropdown-item @click.native="logout">退出</ul-dropdown-item>
        </ul-dropdown-menu>
      </ul-dropdown>
    </div>
    <ul-button type="primary" size="small" v-else @click="toLogin"><span>登录 / 注册</span></ul-button>
  </div>
</template>

<script>
import avatar from '@/mixins/avatar.js'
import { mapGetters } from 'vuex'
import { UMOOC_COOKIE_DOMAIN } from '@/config'
import cookies from '@/utils/cookie'
export default {
  name: 'component-user-info',
  mixins: [avatar],
  computed: {
    ...mapGetters({'user': 'user/user', 'org': 'org/org'}),
  },
  methods: {
    toMyHomePage () {
      switch (this.user.role) {
        case 182:
        case 183:
          window.location.href = `https://www${UMOOC_COOKIE_DOMAIN}/admin`
          break;
        case 184:
          window.location.href = `https://www${UMOOC_COOKIE_DOMAIN}/umooc/service/service.do?operation=toolKit`
          break;
        case 250:
          window.location.href = `https://ua${UMOOC_COOKIE_DOMAIN}/createCourse/#/main/courseList/editing`
          break;
        case 8:
        case 9:
          window.location.href = `https://www${UMOOC_COOKIE_DOMAIN}/ulearning/index.html#/index/courseList`
          break;
        default:
          window.location.href = `https://www${UMOOC_COOKIE_DOMAIN}/ulearning/index.html#/index/courseList`
      }
    },
    logout () {
      this.user.logout()
    },
    toLogin () {
      cookies.set('loginRedirectUrl', location.href)
      this.$router.push({
        path: '/login'
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.user{
  display: flex;
  align-items: center;
  &.unlogin{
    cursor: pointer;
    i{
      font-size: 20px;
      color: $--color-primary;
      margin-right: 8px;
    }
  }
}
.avatar{
  height: 32px;
  width: 32px;
  margin-right: 8px;
  border-radius: 100%;
}
.ul-dropdown{
  line-height: 36px;
}
.ul-select {
  width: 110px;
}
::v-deep {
  .ul-dropdown__trigger{
    // color: $--color-primary;
    cursor: pointer;
  }
  .ul-input__inner{
    background-color: $--color-white;
    border: none;
    // color: $--color-primary;
  }
}
</style>